import { AppointmentItem } from 'old/components/appointment/appointment-item/appointment-item'
import { AppointmentFilter } from 'old/components/appointment/appointment-navigation/appointment-navigation'
import { useAppointments } from 'old/api'
import { VerticalPaginatedList } from 'old/components/vertical-paginated-list/vertical-paginated-list'
import { VerticalContainer } from 'old/components/styled'
import { Appointment }  from 'old/types'
import { useState } from 'react'
import { Drawer } from 'antd'
import { AppointmentDetails } from 'old/components/appointment-details/appointment-details/appointment-details'
import { getShopId, setUnavailableCache, useWindowDimensions }  from 'old/utils'

type Props = {
    teamMemberId: string | null,
    search: string | null,
    filter: AppointmentFilter,
    start: string | null,
    end: string | null
}

export const AppointmentList = ({ teamMemberId, search, filter, start, end }: Props) => {

    //window dimensions:
    const { width, SM } = useWindowDimensions()
    
    //appointments:
    const {
        data: appointments,
        pageNum,
        totalPage,
        isLoading,
        isPreviousData,
        isNextDisabled,
        isPreviousDisabled,
        fetchNext,
        fetchPrevious
    } = useAppointments(teamMemberId, null, search, filter, start, end, 20, true)

    //state:
    const [ selectedAppointmentId, setSelectedAppointmentId ] = useState(null as string | null)
    const [ isAppointmentDetailsOpen, setIsAppointmentDetailsOpen ] = useState(false)

    //openAppointmentDetails:
    const openAppointmentDetails = (appointment: Appointment) => {
        setUnavailableCache(['appointment', appointment.id, getShopId()], appointment)
        setSelectedAppointmentId(appointment.id)
        setIsAppointmentDetailsOpen(true)
    }
    
    //render:
    return (
        <VerticalContainer style={{ gap: 0 }}>

            <VerticalPaginatedList
                isFirstLoading={isLoading}
                isForbidden={appointments === null}
                isError={appointments === false}
                notFound={(appointments && appointments.length === 0) ?? false}
                totalPage={totalPage}
                pageNum={pageNum}
                isPreviousData={isPreviousData}
                isNextDisabled={isNextDisabled}
                isPreviousDisabled={isPreviousDisabled}
                fetchNext={fetchNext}
                fetchPrevious={fetchPrevious}
            >

                <VerticalContainer style={{ width: '100%', gap: 0 }}>

                    {appointments && appointments?.map(appointment =>
                        <AppointmentItem
                            key={appointment.id}
                            appointment={appointment}
                            onClick={() => openAppointmentDetails(appointment)}
                        />
                    )}

                </VerticalContainer>

            </VerticalPaginatedList>


            {/* drawer */}
            <Drawer
                closable={false}
                width={SM ? 450 : width } // full width in mobile
                open={isAppointmentDetailsOpen}
                styles={{ body: { padding: 0 }}}
                onClose={() => {
                    setIsAppointmentDetailsOpen(false)
                    setSelectedAppointmentId(null)
                }}
            >
                
                {selectedAppointmentId && (
                    <AppointmentDetails
                        appointmentId={selectedAppointmentId}
                        isOpen={isAppointmentDetailsOpen}
                        onClose={() => {
                            setIsAppointmentDetailsOpen(false)
                            setSelectedAppointmentId(null)
                        }}
                    />
                )}
                
            </Drawer>

        </VerticalContainer>
    )
    
}
